




































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import {
  CaseDateFilter,
  CaseLogEntry,
  CaseTaskRecord,
  CaseTasks,
} from "@/store/modules/types";
import { filterOn } from "@/utils";
import InputPopover from "@/components/InputPopover.vue";
import SelectPopover from "@/components/SelectPopover.vue";
import DatePopover from "@/components/DatePopover.vue";
import DateRangePopover from "@/components/DateRangePopover.vue";
import { CaseLogType, CaseTaskStatus } from "@/store/modules/enums";
import PatientFilterPopover from "@/components/PatientFilterPopover.vue";

@Component({
  components: {
    InputPopover,
    SelectPopover,
    DatePopover,
    DateRangePopover,
    PatientFilterPopover,
  },
  computed: {
    ...mapState("cases", ["tasks", "types", "users", "carePlan"]),
    ...mapGetters("cases", [
      "caseIdFilterOn",
      "patientFilterOn",
      "typeFilterOn",
      "activityFilterOn",
      "riskLevelFilterOn",
      "statusFilterOn",
      "createdFilterOn",
      "updatedFilterOn",
    ]),
  },
})
export default class TaskList extends Vue {
  tasks!: CaseTasks;
  carePlan!: any;
  selected: any = null;
  setOrderBy(field: string) {
    this.$store.commit("cases/SET_CASE_TASKS_ORDER_BY_FILTER", field);
  }
  setCaseIdFilter(value: string) {
    this.$store.commit("cases/SET_CASE_TASKS_CASE_ID_FILTER", value);
  }
  setTaskIdFilter(value: string) {
    this.$store.commit("cases/SET_CASE_TASKS_ID_FILTER", value);
  }
  setPatientFilter(value: any) {
    this.$store.commit("cases/SET_CASE_TASKS_PATIENT_FILTER", value);
  }
  setCaseTypeFilter(value: number[]) {
    this.$store.commit("cases/SET_CASE_TASKS_CASE_TYPE_FILTER", value);
  }
  setStatusFilter(value: any[]) {
    this.$store.commit("cases/SET_CASE_TASKS_STATUS_FILTER", value);
  }
  setPriorityFilter(value: any[]) {
    this.$store.commit("cases/SET_CASE_TASKS_PRIORITY_FILTER", value);
  }
  setOwnerFilter(value: number[]) {
    this.$store.commit("cases/SET_CASE_TASKS_OWNER_FILTER", value);
  }
  setDueDateFilter(from, to) {
    const filter: CaseDateFilter = { from, to };
    this.$store.commit("cases/SET_CASE_TASKS_DUE_DATE_FILTER", filter);
  }
  setCreatedFilter(from, to) {
    const filter: CaseDateFilter = { from, to };
    console.log(filter);
    this.$store.commit("cases/SET_CASE_TASKS_CREATED_FILTER", filter);
  }
  async save(task) {
    const {
      caseId,
      key,
      id,
      carePlanTaskId,
      description,
      statusId,
      priorityId,
      dueDate,
      ownerUserId,
    }: CaseTaskRecord = task;
    try {
      const status = this.carePlan.taskStatus.find((t) => t.id === statusId);
      const priority = this.carePlan.taskPriority.find(
        (p) => p.id === priorityId
      );
      if (status) {
        task.statusBackColor = status.backColor;
        task.statusFontColor = status.fontColor;
      }
      if (priority) {
        task.priorityBackColor = priority.backColor;
        task.priorityFontColor = priority.fontColor;
      }
      await this.$store.dispatch("cases/saveTask", {
        caseId,
        key,
        id,
        carePlanTaskId,
        description,
        statusId,
        priorityId,
        dueDate,
        ownerUserId,
      });
      if (statusId === CaseTaskStatus.CLOSED) {
        task.closeDate = new Date();
      }
      this.$bvToast.toast(`Task #${id} updated.`, {
        title: "WaitingMed",
        toaster: "b-toaster-top-right",
        autoHideDelay: 2000,
        solid: true,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveComment(comment) {
    if (!this.selected || !comment) return;
    const { id, caseId } = this.selected;
    const entry: CaseLogEntry = {
      caseId,
      taskId: id,
      typeId: CaseLogType.TASK_COMMENT,
      comment,
    };
    try {
      await this.$store.dispatch("cases/saveLog", entry);
      this.$bvToast.toast(`Task #${id} updated.`, {
        title: "WaitingMed",
        toaster: "b-toaster-top-right",
        autoHideDelay: 2000,
        solid: true,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  get orderBy(): string {
    return this.tasks.filter.orderBy;
  }
  get patientFilterOn() {
    return filterOn(this.tasks.filter.patient);
  }
}
